import { mapValues } from 'lodash';
/**
 * Version 41 migrations:
 * 1. Adding Edit, Delete, Summary Instruction & Cancel Text for Air Request
 * 2. Adding Edit, Delete, Summary Instruction, Cancel, Hotel Description, Choose your room,
 *    Preferences and Request another room Text for Hotel Request
 */
export default function v41(website) {
  return {
    ...website,
    eventVersion: 41,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'AirRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            airRequestSummaryEditButtonText: 'EventWidgets_AirRequestSummary_Edit__resx',
            airRequestSummaryDeleteButtonText: 'EventWidgets_AirRequestSummary_Delete__resx',
            airRequestSummaryInstructionText: 'EventWidgets_AirRequestSummary_RequestSummaryInstruction__resx',
            airRequestCancellationButtonText: '_registrationNavigatorWidget_exitDefaultDisplayText__resx'
          }
        };
      } else if (layoutItem.widgetType === 'HotelRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            hotelRequestSummaryEditButtonText: 'EventWidgets_HotelRequest_Edit__resx',
            hotelRequestSummaryDeleteButtonText: 'EventWidgets_HotelRequest_Delete__resx',
            hotelRequestSummaryInstructionText: 'EventWidgets_AirRequestSummary_RequestSummaryInstruction__resx',
            hotelRequestCancellationText: '_registrationNavigatorWidget_exitDefaultDisplayText__resx',
            hotelDescriptionText: 'EventWidgets_HotelRequest_Description__resx',
            hotelChooseYourRoomText: 'EventWidgets_HotelRequest_SelectRoomHeader__resx',
            hotelPreferencesAndSpecialRequestText: 'EventWidgets_HotelRequest_Preferences__resx',
            hotelRequestAnotherRoomButtonText: 'EventWidgets_HotelRequest_MakeAnotherRequestButton__resx'
          }
        };
      }
      return layoutItem;
    })
  };
}
